import { State } from '@clh/api-client';
export const StateAbbrToDisplayName = {
    [State.Al]: 'Alabama',
    [State.Ak]: 'Alaska',
    [State.Az]: 'Arizona',
    [State.Ar]: 'Arkansas',
    [State.Ca]: 'California',
    [State.Co]: 'Colorado',
    [State.Ct]: 'Connecticut',
    [State.De]: 'Delaware',
    [State.Dc]: 'District of Columbia',
    [State.Fl]: 'Florida',
    [State.Ga]: 'Georgia',
    [State.Hi]: 'Hawaii',
    [State.Id]: 'Idaho',
    [State.Il]: 'Illinois',
    [State.In]: 'Indiana',
    [State.Ia]: 'Iowa',
    [State.Ks]: 'Kansas',
    [State.Ky]: 'Kentucky',
    [State.La]: 'Louisiana',
    [State.Me]: 'Maine',
    [State.Md]: 'Maryland',
    [State.Ma]: 'Massachusetts',
    [State.Mi]: 'Michigan',
    [State.Mn]: 'Minnesota',
    [State.Ms]: 'Mississippi',
    [State.Mo]: 'Missouri',
    [State.Mt]: 'Montana',
    [State.Ne]: 'Nebraska',
    [State.Nv]: 'Nevada',
    [State.Nh]: 'New Hampshire',
    [State.Nj]: 'New Jersey',
    [State.Nm]: 'New Mexico',
    [State.Ny]: 'New York',
    [State.Nc]: 'North Carolina',
    [State.Nd]: 'North Dakota',
    [State.Oh]: 'Ohio',
    [State.Ok]: 'Oklahoma',
    [State.Or]: 'Oregon',
    [State.Pa]: 'Pennsylvania',
    [State.Pr]: 'Puerto Rico',
    [State.Ri]: 'Rhode Island',
    [State.Sc]: 'South Carolina',
    [State.Sd]: 'South Dakota',
    [State.Tn]: 'Tennessee',
    [State.Tx]: 'Texas',
    [State.Ut]: 'Utah',
    [State.Vt]: 'Vermont',
    [State.Va]: 'Virginia',
    [State.Wa]: 'Washington',
    [State.Wv]: 'West Virginia',
    [State.Wi]: 'Wisconsin',
    [State.Wy]: 'Wyoming',
};
